<div>
  <sd-form-field-new [control]="control" [label]="label">
    <sd-select>
      <ng-select
        [items]="suggestions$ | async"
        bindLabel="value"
        bindValue="value"
        [loading]="suggestIsLoading$ | async"
        loadingText="Идет поиск..."
        notFoundText="Ничего не найдено"
        typeToSearchText="Начинайте вводить адрес доставки"
        [dropdownPosition]="'bottom'"
        [editableSearchTerm]="true"
        [formControl]="control"
        [typeahead]="selectTypeahead"
        [clearable]="false"
        (change)="onChangeSelect($event)"
        (blur)="onBlurSelect($event)"
      ></ng-select>
    </sd-select>
  </sd-form-field-new>
</div>
